/* Emoji.tsx generated by @compiled/babel-plugin v0.40.0 */
import { ax, ix } from "@compiled/react/runtime";
require("@compiled/webpack-loader/css-loader!@compiled/webpack-loader/css-loader/compiled-css.css?style=._19pk1n1a%7Bmargin-top%3A-1px%7D");
require("@compiled/webpack-loader/css-loader!@compiled/webpack-loader/css-loader/compiled-css.css?style=._2hwxidpf%7Bmargin-right%3A0%7D");
require("@compiled/webpack-loader/css-loader!@compiled/webpack-loader/css-loader/compiled-css.css?style=._otyr1n1a%7Bmargin-bottom%3A-1px%7D");
require("@compiled/webpack-loader/css-loader!@compiled/webpack-loader/css-loader/compiled-css.css?style=._18u0idpf%7Bmargin-left%3A0%7D");
require("@compiled/webpack-loader/css-loader!@compiled/webpack-loader/css-loader/compiled-css.css?style=._1e0c1o8l%7Bdisplay%3Ainline-block%7D");
require("@compiled/webpack-loader/css-loader!@compiled/webpack-loader/css-loader/compiled-css.css?style=._jr50g2xd%20.emoji-common-emoji-sprite%7Bbackground%3Atransparent%20no-repeat%7D");
require("@compiled/webpack-loader/css-loader!@compiled/webpack-loader/css-loader/compiled-css.css?style=._ylp71o8l%20.emoji-common-emoji-sprite%7Bdisplay%3Ainline-block%7D");
require("@compiled/webpack-loader/css-loader!@compiled/webpack-loader/css-loader/compiled-css.css?style=._pkaxgktf%20.emoji-common-emoji-sprite%7Bmin-height%3A20px%7D");
require("@compiled/webpack-loader/css-loader!@compiled/webpack-loader/css-loader/compiled-css.css?style=._1hdcgktf%20.emoji-common-emoji-sprite%7Bmin-width%3A20px%7D");
require("@compiled/webpack-loader/css-loader!@compiled/webpack-loader/css-loader/compiled-css.css?style=._109tnkob%20.emoji-common-emoji-sprite%7Bvertical-align%3Amiddle%7D");
require("@compiled/webpack-loader/css-loader!@compiled/webpack-loader/css-loader/compiled-css.css?style=._tn8j1dpa.emoji-common-select-on-hover%3Ahover%7Bbackground-color%3Avar(--ds-background-neutral-subtle-hovered%2C%230515240f)%7D");
require("@compiled/webpack-loader/css-loader!@compiled/webpack-loader/css-loader/compiled-css.css?style=._3naf1dpa.emoji-common-selected%7Bbackground-color%3Avar(--ds-background-neutral-subtle-hovered%2C%230515240f)%7D");
require("@compiled/webpack-loader/css-loader!@compiled/webpack-loader/css-loader/compiled-css.css?style=._nt751r31%3Afocus%7Boutline-color%3AcurrentColor%7D");
require("@compiled/webpack-loader/css-loader!@compiled/webpack-loader/css-loader/compiled-css.css?style=._49pcglyw%3Afocus%7Boutline-style%3Anone%7D");
require("@compiled/webpack-loader/css-loader!@compiled/webpack-loader/css-loader/compiled-css.css?style=._1hvw1o36%3Afocus%7Boutline-width%3Amedium%7D");
require("@compiled/webpack-loader/css-loader!@compiled/webpack-loader/css-loader/compiled-css.css?style=._7ehi1y54%3Afocus%7Bbox-shadow%3A0%200%200%202px%20var(--ds-border-focused%2C%234688ec)%7D");
require("@compiled/webpack-loader/css-loader!@compiled/webpack-loader/css-loader/compiled-css.css?style=._491113zc%3Afocus%7Btransition-duration%3A0s%2C.2s%7D");
require("@compiled/webpack-loader/css-loader!@compiled/webpack-loader/css-loader/compiled-css.css?style=._bfhk1j28%7Bbackground-color%3Atransparent%7D");
require("@compiled/webpack-loader/css-loader!@compiled/webpack-loader/css-loader/compiled-css.css?style=._s7n4nkob%7Bvertical-align%3Amiddle%7D");
require("@compiled/webpack-loader/css-loader!@compiled/webpack-loader/css-loader/compiled-css.css?style=._160jewfl.emoji-common-select-on-hover%3Ahover%20.emoji-common-deleteButton%7Bvisibility%3Avisible%7D");
require("@compiled/webpack-loader/css-loader!@compiled/webpack-loader/css-loader/compiled-css.css?style=._1theewfl.emoji-common-selected%7Bvisibility%3Avisible%7D");
require("@compiled/webpack-loader/css-loader!@compiled/webpack-loader/css-loader/compiled-css.css?style=._1kogh2mm.emoji-common-deletable%7Bposition%3Arelative%7D");
require("@compiled/webpack-loader/css-loader!@compiled/webpack-loader/css-loader/compiled-css.css?style=._qyp0ewfl.emoji-common-deletable%3Afocus-within%20.emoji-common-deleteButton%7Bvisibility%3Avisible%7D");
require("@compiled/webpack-loader/css-loader!@compiled/webpack-loader/css-loader/compiled-css.css?style=._2rkofajl%7Bborder-radius%3Avar(--ds-radius-small%2C3px)%7D");
require("@compiled/webpack-loader/css-loader!@compiled/webpack-loader/css-loader/compiled-css.css?style=._v4pn1ule%20img%7Bdisplay%3Ablock%7D");
import React, { useEffect, useCallback, useContext, useMemo, useState, type FocusEvent, type MouseEvent, type SyntheticEvent, forwardRef, type PropsWithChildren } from 'react';
import { IntlContext } from 'react-intl';
import Tooltip from '@atlaskit/tooltip';
import { shouldUseAltRepresentation } from '../../api/EmojiUtils';
import { defaultEmojiHeight, deleteEmojiLabel, EMOJI_KEYBOARD_KEYS_SUPPORTED, KeyboardKeys, SAMPLING_RATE_EMOJI_RENDERED_EXP } from '../../util/constants';
import { isImageRepresentation, isMediaRepresentation, isSpriteRepresentation, isUnicodeRepresentation, toEmojiId } from '../../util/type-helpers';
import { type EmojiDescription, type OnEmojiEvent, ProviderTypes, type SpriteRepresentation, UfoEmojiTimings, type UnicodeRepresentation } from '../../types';
import { leftClick } from '../../util/mouse';
import DeleteButton from './DeleteButton';
import { emojiNodeStyles, commonSelectedStyles, selectOnHoverStyles, emojiSprite, emojiMainStyle, emojiImage, deletableEmoji } from './styles';
import { sampledUfoRenderedEmoji, ufoExperiences, useSampledUFOComponentExperience } from '../../util/analytics';
import browserSupport from '../../util/browser-support';
import { useInView } from '../../hooks/useInView';
import { hasUfoMarked } from '../../util/analytics/ufoExperiences';
import { DeletableEmojiTooltipContent, DeletableEmojiTooltipContentForScreenReader } from './DeletableEmojiTooltipContent';
import { expValEquals } from '@atlaskit/tmp-editor-statsig/exp-val-equals';
import { getDocument } from '@atlaskit/browser-apis';
import { messages } from '../i18n';
import { isSSR } from '../../util/is-ssr';
import { renderUnicodeEmojiToImagePath } from '../../util/renderUnicodeEmojiToImagePath';
import EmojiPlaceholder from './EmojiPlaceholder';
const emojiSpriteContainer = null;
const emojiImageContainer = null;

// Unicode emojis render as text inside a <span>, not an <img>, so they do not need
// borderRadius (which would clip a background on hover) or the img { display: block } rule.
const emojiUnicodeContainer = null;
export interface Props extends Omit<React.HTMLAttributes<HTMLSpanElement>, 'onMouseMove' | 'onFocus'> {
  /**
   * Auto Width takes the constraint of height and enables native scaling based on the emojis image.
   * This is primarily used when rendering emojis for SSR as the component does not know the width and height
   * at the time of the render. It overrides the emoji representations width with 'auto' on the images width attribute
   *
   * Used only for image based emojis
   */
  autoWidth?: boolean;

  /**
   * Additional css classes, if required.
   */
  className?: string;

  /**
   * Disables lazy load on images
   */
  disableLazyLoad?: boolean;

  /**
   * This should only be set when the emoji is being used in the Editor.
   * Currently when set -- this prevents any aria labels being added.
   * This is acceptable in Editor -- as it uses another technique to announce the emoji nodes.
   */
  editorEmoji?: true;

  /**
   * The emoji to render
   */
  emoji: EmojiDescription;

  /**
   * Fits emoji to height in pixels, keeping aspect ratio
   */
  fitToHeight?: number;

  /**
   * Called when an emoji is deleted
   */
  onDelete?: OnEmojiEvent;

  /**
   * Called when the mouse moves over the emoji.
   */
  onFocus?: OnEmojiEvent;

  /**
   * Callback for if an emoji image fails to load.
   */
  onLoadError?: OnEmojiEvent<HTMLImageElement>;

  /**
   * Callback for if an emoji image succesfully loads.
   */
  onLoadSuccess?: (emoji: EmojiDescription) => void;

  /**
   * Called when the mouse moves over the emoji.
   */
  onMouseMove?: OnEmojiEvent;

  /**
   * Called when an emoji is selected
   */
  onSelected?: OnEmojiEvent;

  /**
   * Prevent mouse selection from moving browser focus to the emoji.
   * Keyboard selection still keeps focus on the emoji for grid navigation.
   */
  preventFocusOnMouseDown?: boolean;

  /**
   * Renders unicode emoji through an image representation when a fixed height is supplied.
   * Defaults to `true`.
   */
  renderUnicodeEmojiAsImage?: boolean;

  /**
   * Show the emoji as selected
   */
  selected?: boolean;

  /**
   * Automatically show the emoji as selected based on mouse hover.
   * CSS, fast, does not require a re-render, but selected state not
   * externally controlled via props.
   */
  selectOnHover?: boolean;

  /**
   * Indicates whether emoji is an interactive element (tab index and role) or just a view
   */
  shouldBeInteractive?: boolean;

  /**
   * Show a delete button on mouse hover
   * Used only for custom emoji
   */
  showDelete?: boolean;

  /**
   * Show a tooltip on mouse hover.
   */
  showTooltip?: boolean;
}
const unicodeEmojiCanvasSize = 128;
type UnicodeEmojiImageState = {
  status: 'loading';
  unicodeEmoji?: string;
} | {
  imagePath: string;
  status: 'ready';
  unicodeEmoji: string;
} | {
  status: 'failed';
  unicodeEmoji: string;
};
const handleMouseDown = (props: Props, event: MouseEvent<any>) => {
  // Clicked emoji delete button
  if (event.target instanceof Element && event.target.getAttribute('aria-label') === deleteEmojiLabel) {
    return;
  }
  const {
    emoji,
    onSelected
  } = props;
  if (onSelected && leftClick(event)) {
    if (props.preventFocusOnMouseDown) {
      event.preventDefault();
    }
    onSelected(toEmojiId(emoji), emoji, event);
  }
};
const handleKeyDown = (props: Props, event: React.KeyboardEvent<HTMLElement>) => {
  if (!EMOJI_KEYBOARD_KEYS_SUPPORTED.includes(event.key)) {
    return;
  }
  event.preventDefault();
  event.stopPropagation();
  const {
    emoji,
    onSelected,
    showDelete
  } = props;
  if (onSelected && (event.key === KeyboardKeys.Enter || event.key === KeyboardKeys.Space)) {
    onSelected(toEmojiId(emoji), emoji, event);
  }
  if (showDelete && event.key === KeyboardKeys.Backspace) {
    handleDelete(props, event);
  }
};
const handleMouseMove = (props: Props, event: MouseEvent<any>) => {
  const {
    emoji,
    onMouseMove
  } = props;
  if (onMouseMove) {
    onMouseMove(toEmojiId(emoji), emoji, event);
  }
};
const handleFocus = (props: Props, event: FocusEvent<any>) => {
  const {
    emoji,
    onFocus
  } = props;
  if (onFocus) {
    onFocus(toEmojiId(emoji), emoji, event);
  }
};
const handleDelete = (props: Props, event: SyntheticEvent) => {
  const {
    emoji,
    onDelete
  } = props;
  if (onDelete) {
    onDelete(toEmojiId(emoji), emoji, event);
  }
};
const handleImageError = (props: Pick<Props, 'emoji' | 'onLoadError'>, event: SyntheticEvent<HTMLImageElement>) => {
  const {
    emoji,
    onLoadError
  } = props;

  // Hide error state (but keep space for it)
  if (event.target) {
    const target = (event.target as HTMLElement);
    target.style.visibility = 'hidden';
  }
  if (onLoadError) {
    onLoadError(toEmojiId(emoji), emoji, event);
  }
};

// Pure functional components are used in favour of class based components, due to the performance!
// When rendering 1500+ emoji using class based components had a significant impact.
// TODO: add UFO tracking for sprite emoji
export const SpriteEmoji = (props: Props): JSX.Element => {
  const {
    emoji,
    fitToHeight,
    selected,
    selectOnHover,
    className
  } = props;
  const representation = (emoji.representation as SpriteRepresentation);
  const sprite = representation.sprite;
  const classes = `${emojiNodeStyles} ${selected ? commonSelectedStyles : ''} ${selectOnHover ? selectOnHoverStyles : ''} ${className ? className : ''}`;
  let sizing = {};
  if (fitToHeight) {
    if (expValEquals('platform_editor_lovability_emoji_scaling', 'isEnabled', true)) {
      sizing = {
        minHeight: `${fitToHeight}px`,
        minWidth: `${fitToHeight}px`
      };
    } else {
      sizing = {
        width: `${fitToHeight}px`,
        height: `${fitToHeight}px`,
        minHeight: `${fitToHeight}px`,
        minWidth: `${fitToHeight}px`
      };
    }
  }
  const xPositionInPercent = 100 / (sprite.column - 1) * (representation.xIndex - 0);
  const yPositionInPercent = 100 / (sprite.row - 1) * (representation.yIndex - 0);
  const style = {
    backgroundImage: `url(${sprite.url})`,
    backgroundPosition: `${xPositionInPercent}% ${yPositionInPercent}%`,
    backgroundSize: `${sprite.column * 100}% ${sprite.row * 100}%`,
    ...sizing
  };
  return (
    // eslint-disable-next-line @atlaskit/ui-styling-standard/no-classname-prop -- Ignored via go/DSP-18766
    <EmojiNodeWrapper {...props} type="sprite" className={classes}>
			{/* eslint-disable-next-line @atlaskit/ui-styling-standard/no-classname-prop, @atlaskit/ui-styling-standard/enforce-style-prop -- Ignored via go/DSP-18766  */}
			<span className={emojiSprite} style={style} />
		</EmojiNodeWrapper>
  );
};
const useUnicodeEmojiImage = (unicodeEmoji: string): UnicodeEmojiImageState => {
  const [state, setState] = useState<UnicodeEmojiImageState>({
    status: 'loading'
  });
  useEffect(() => {
    let cancelled = false;
    let imagePathToRevoke: string | undefined;
    setState({
      status: 'loading',
      unicodeEmoji
    });
    void renderUnicodeEmojiToImagePath(unicodeEmoji).then(imagePath => {
      if (cancelled) {
        if (imagePath) {
          URL.revokeObjectURL(imagePath);
        }
        return;
      }
      imagePathToRevoke = imagePath;
      setState(imagePath ? {
        status: 'ready',
        unicodeEmoji,
        imagePath
      } : {
        status: 'failed',
        unicodeEmoji
      });
    }).catch(() => {
      if (!cancelled) {
        setState({
          status: 'failed',
          unicodeEmoji
        });
      }
    });
    return () => {
      cancelled = true;
      if (imagePathToRevoke) {
        URL.revokeObjectURL(imagePathToRevoke);
      }
    };
  }, [unicodeEmoji]);
  return state;
};
const UnicodeEmojiImage = (props: Props): JSX.Element => {
  const {
    emoji,
    fitToHeight,
    showTooltip
  } = props;
  const emojiText = (emoji.representation as UnicodeRepresentation).unicodeEmoji;
  const unicodeEmojiImage = useUnicodeEmojiImage(emojiText);
  const hasCurrentEmojiImage = unicodeEmojiImage.unicodeEmoji === emojiText;
  if (isSSR() || !hasCurrentEmojiImage || unicodeEmojiImage.status === 'loading') {
    return <EmojiPlaceholder shortName={emoji.shortName} showTooltip={showTooltip} size={fitToHeight} loading />;
  }
  if (unicodeEmojiImage.status === 'ready') {
    return <ImageEmoji {...props} emoji={{
      ...emoji,
      altRepresentation: undefined,
      representation: {
        imagePath: unicodeEmojiImage.imagePath,
        width: unicodeEmojiCanvasSize,
        height: unicodeEmojiCanvasSize
      }
    }} />;
  }
  return <EmojiPlaceholder shortName={emoji.shortName} showTooltip={showTooltip} size={fitToHeight} />;
};
export const UnicodeEmoji = (props: Props): JSX.Element => {
  const {
    emoji,
    selected,
    selectOnHover,
    className,
    fitToHeight,
    renderUnicodeEmojiAsImage = true
  } = props;
  if (renderUnicodeEmojiAsImage) {
    return <UnicodeEmojiImage {...props} />;
  }
  const classes = `${emojiNodeStyles} ${selected ? commonSelectedStyles : ''} ${selectOnHover ? selectOnHoverStyles : ''} ${className ? className : ''}`;
  const emojiText = (emoji.representation as UnicodeRepresentation).unicodeEmoji;
  const defaultSize = `${fitToHeight ?? defaultEmojiHeight}px`;
  const emojiSize = `var(--emoji-common-unicode-size, ${defaultSize})`;
  const style: React.CSSProperties = {
    display: 'inline-flex',
    // eslint-disable-next-line @atlaskit/design-system/use-tokens-typography
    fontSize: emojiSize,
    alignItems: 'center',
    aspectRatio: '1/1'
  };
  return (
    // eslint-disable-next-line @atlaskit/ui-styling-standard/no-classname-prop
    <EmojiNodeWrapper {...props} type="unicode" className={classes}>
			{/* eslint-disable-next-line @atlaskit/ui-styling-standard/enforce-style-prop */}
			<span style={style}>{emojiText}</span>
		</EmojiNodeWrapper>
  );
};

// Keep as pure functional component, see renderAsSprite.
export const ImageEmoji = (props: Props): JSX.Element => {
  const {
    emoji,
    fitToHeight,
    selected,
    selectOnHover,
    className,
    showDelete,
    onLoadSuccess,
    disableLazyLoad,
    autoWidth
  } = props;
  const [ref, inView] = useInView({
    triggerOnce: true
  });
  const ufoExp = useMemo(() => sampledUfoRenderedEmoji(emoji), [emoji]);
  const classes = `${emojiMainStyle} ${emojiNodeStyles} ${selected ? commonSelectedStyles : ''} ${selectOnHover ? selectOnHoverStyles : ''} ${emojiImage} ${className ? className : ''} ${showDelete ? deletableEmoji : ''}`;
  let width;
  let height;
  let src;
  const representation = shouldUseAltRepresentation(emoji, fitToHeight) ? emoji.altRepresentation : emoji.representation;
  if (isImageRepresentation(representation)) {
    src = representation.imagePath;
    width = representation.width;
    height = representation.height;
  } else if (isMediaRepresentation(representation)) {
    src = representation.mediaPath;
    width = representation.width;
    height = representation.height;
  }
  let sizing = {};
  if (fitToHeight && width && height) {
    const sizingWidth = autoWidth ? 'auto' : fitToHeight / height * width;
    // Presize image, to prevent reflow due to size changes after loading
    sizing = {
      width: sizingWidth,
      height: fitToHeight
    };
  }
  const onError = useCallback((event: SyntheticEvent<HTMLImageElement>) => {
    handleImageError({
      emoji: props.emoji,
      onLoadError: props.onLoadError
    }, event);
  }, [props.emoji, props.onLoadError]);
  const onLoad = useCallback(() => {
    const mountedMark = ufoExp.metrics.marks.find(mark => mark.name === UfoEmojiTimings.MOUNTED_END);
    // onload could trigger before onBeforeLoad when emojis in viewport at start, so we need to mark onload start manually.
    if (!hasUfoMarked(ufoExp, UfoEmojiTimings.ONLOAD_START)) {
      ufoExp.mark(UfoEmojiTimings.ONLOAD_START, mountedMark?.time);
    }
    const loadedStartMark = ufoExp.metrics.marks.find(mark => mark.name === UfoEmojiTimings.ONLOAD_START);
    if (mountedMark && loadedStartMark) {
      ufoExp.addMetadata({
        lazyLoad: loadedStartMark.time > mountedMark.time
      });
    }
    // onload_start
    if (!hasUfoMarked(ufoExp, UfoEmojiTimings.ONLOAD_END)) {
      ufoExp.mark(UfoEmojiTimings.ONLOAD_END);
    }
    ufoExp.success({
      metadata: {
        IBSupported: browserSupport.supportsIntersectionObserver
      }
    });
    if (onLoadSuccess) {
      onLoadSuccess(emoji);
    }
  }, [emoji, onLoadSuccess, ufoExp]);
  const onBeforeLoad = useCallback(() => {
    if (!hasUfoMarked(ufoExp, UfoEmojiTimings.ONLOAD_START)) {
      ufoExp.mark(UfoEmojiTimings.ONLOAD_START);
    }
  }, [ufoExp]);
  const onMouseOver = useCallback((e: React.MouseEvent<HTMLElement>) => {
    // only disable tooltip when not on focus
    if (!getDocument()?.activeElement?.contains((e.target as Node))) {
      e.stopPropagation();
    }
  }, []);

  // because of the lack of browser support of on before load natively, used IntersectionObserver helper hook to mimic the before load time mark for UFO.
  useEffect(() => {
    if (inView) {
      onBeforeLoad();
    }
  }, [inView, onBeforeLoad]);
  const emojiNode = <img
  //@ts-ignore
  loading={disableLazyLoad ? 'eager' : 'lazy'} src={src} key={src} alt={emoji.name || emoji.shortName || ''} data-emoji-short-name={emoji.shortName} data-emoji-id={emoji.id} data-emoji-text={emoji.fallback || emoji.shortName}
  // eslint-disable-next-line @atlaskit/ui-styling-standard/no-classname-prop -- Ignored via go/DSP-18766
  className="emoji"
  // eslint-disable-next-line @atlaskit/ui-styling-standard/enforce-style-prop -- Ignored via go/DSP-18766
  style={{
    visibility: 'visible'
  }} onError={onError} onLoad={onLoad} {...sizing} data-vc="emoji" />;

  // show a tooltip for deletable emoji only on focus
  if (showDelete) {
    return <Tooltip content={<DeletableEmojiTooltipContent />} position="right-start" tag="span">
				<EmojiNodeWrapper {...props} aria-labelledby={`screenreader-emoji-${emoji.id}`} type="image"
      // eslint-disable-next-line @atlaskit/ui-styling-standard/no-classname-prop -- Ignored via go/DSP-18766
      className={classes} ref={ref} showTooltip={false} // avoid showing both tooltip and title
      onMouseOver={onMouseOver}>
					{emojiNode}
					<DeleteButton onClick={(event: SyntheticEvent) => handleDelete(props, event)} />
					<DeletableEmojiTooltipContentForScreenReader emoji={emoji} />
				</EmojiNodeWrapper>
			</Tooltip>;
  }
  return (
    // eslint-disable-next-line @atlaskit/ui-styling-standard/no-classname-prop -- Ignored via go/DSP-18766
    <EmojiNodeWrapper {...props} type="image" className={classes} ref={ref}>
			{emojiNode}
		</EmojiNodeWrapper>
  );
};
interface EmojiNodeWrapperProps extends Props {
  type: 'sprite' | 'image' | 'unicode';
}
export const EmojiNodeWrapper: React.ForwardRefExoticComponent<EmojiNodeWrapperProps & {
  children?: React.ReactNode | undefined;
} & React.RefAttributes<HTMLSpanElement>> = forwardRef<HTMLSpanElement, PropsWithChildren<EmojiNodeWrapperProps>>((props, ref) => {
  const {
    emoji,
    fitToHeight,
    selected,
    selectOnHover,
    className,
    showTooltip,
    showDelete,
    shouldBeInteractive = false,
    tabIndex,
    onSelected,
    onMouseMove,
    onFocus,
    onDelete,
    onLoadError,
    onLoadSuccess,
    disableLazyLoad,
    autoWidth,
    children,
    type,
    editorEmoji,
    renderUnicodeEmojiAsImage,
    ...other
  } = props;
  const intl = useContext(IntlContext);
  const ariaLabel = editorEmoji ? undefined : intl ? intl.formatMessage(messages.changeEmojiShortnameButtonLabel, {
    shortName: emoji.name ?? emoji.shortName
  }) : emoji.shortName;
  return <span role={editorEmoji ? undefined : shouldBeInteractive ? 'button' : ariaLabel ? 'img' : 'presentation'} aria-label={ariaLabel} ref={ref} data-testid={`${type}-emoji-${emoji.shortName}`} data-emoji-type={type} tabIndex={shouldBeInteractive ? tabIndex || 0 : undefined}
  // eslint-disable-next-line @atlaskit/ui-styling-standard/no-classname-prop -- Ignored via go/DSP-18766
  className={ax([type === 'sprite' ? "_19pk1n1a _2hwxidpf _otyr1n1a _18u0idpf _1e0c1o8l _jr50g2xd _ylp71o8l _pkaxgktf _1hdcgktf _109tnkob _tn8j1dpa _3naf1dpa _nt751r31 _49pcglyw _1hvw1o36 _7ehi1y54 _491113zc" : type === 'unicode' ? "_19pk1n1a _2hwxidpf _otyr1n1a _18u0idpf _bfhk1j28 _1e0c1o8l _s7n4nkob _tn8j1dpa _3naf1dpa _160jewfl _1theewfl _1kogh2mm _qyp0ewfl _nt751r31 _49pcglyw _1hvw1o36 _7ehi1y54 _491113zc" : "_2rkofajl _19pk1n1a _2hwxidpf _otyr1n1a _18u0idpf _bfhk1j28 _1e0c1o8l _s7n4nkob _v4pn1ule _tn8j1dpa _3naf1dpa _160jewfl _1theewfl _1kogh2mm _qyp0ewfl _nt751r31 _49pcglyw _1hvw1o36 _7ehi1y54 _491113zc", className])} onKeyDown={event => handleKeyDown(props, event)} onMouseDown={event => {
    handleMouseDown(props, event);
  }} onMouseEnter={event => {
    handleMouseMove(props, event);
  }} onFocus={event => {
    handleFocus(props, event);
  }} title={showTooltip ? emoji.shortName : undefined} // TODO: COLLAB-2351 - use @atlaskit/Tooltip in future for non-deletable emoji if enabled showTooltip
  {...other}>
			{children}
		</span>;
});
export const Emoji = (props: Props): JSX.Element => {
  const {
    emoji
  } = props;
  // start emoji rendered experience, it may have already started earlier in ResourcedEmoji or CachingEmoji
  useSampledUFOComponentExperience(ufoExperiences['emoji-rendered'].getInstance(emoji.id || emoji.shortName), SAMPLING_RATE_EMOJI_RENDERED_EXP, {
    source: 'Emoji',
    emojiId: emoji.id
  });
  useEffect(() => {
    const ufoExp = sampledUfoRenderedEmoji(emoji);
    if (!hasUfoMarked(ufoExp, 'fmp')) {
      ufoExp.markFMP();
    }
    if (!hasUfoMarked(ufoExp, UfoEmojiTimings.MOUNTED_END)) {
      ufoExp.mark(UfoEmojiTimings.MOUNTED_END);
    }
    if (emoji.type === ProviderTypes.STANDARD || isUnicodeRepresentation(emoji.representation)) {
      expValEquals('platform_use_unicode_emojis', 'isEnabled', true);
    }
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, []);
  if (isUnicodeRepresentation(emoji.representation)) {
    return <UnicodeEmoji {...props} />;
  }
  // TODO: We always prefer render as image as having accessibility issues with sprite representation
  if (isSpriteRepresentation(emoji.representation)) {
    return <SpriteEmoji {...props} />;
  }
  return <ImageEmoji {...props} />;
};
export default Emoji;